<script setup lang="ts">
import { setLocationToEnquiryPage } from '@/composables/enquiry.helpers'
import { ACCOSLISTPAGEFILTER, CULTURE } from '@/composables/helpers'
import { EnquiryType } from '@/composables/interfaces/appInterfaces'
import { useAccosCountApi } from '@/composables/useApi'
import { MaximalAmountDisplayingGeneralEnquiry } from '@/constants'
import t from '@/i18n/translations'
import { accosApiResults } from '@/store/filter.store'
import { ref } from 'vue'

const props = defineProps<{
  usedOnFilterPage?: boolean | undefined // is needed to know if enquirybar is used on filterpage or on accoslistpage
}>()

const disableButton = ref<boolean>(false)

const accosCountEnquiryBar = ref<number>() // accos count for enquirybar on accos list page

if (ACCOSLISTPAGEFILTER != null) {
  const result = await useAccosCountApi(JSON.parse(ACCOSLISTPAGEFILTER))
  if (result.data != null) {
    accosCountEnquiryBar.value = result.data
    accosCountEnquiryBar.value > MaximalAmountDisplayingGeneralEnquiry
      ? (accosCountEnquiryBar.value = MaximalAmountDisplayingGeneralEnquiry)
      : accosCountEnquiryBar.value
  }
}

const text = () => {
  if (props.usedOnFilterPage) {
    if (accosApiResults.value != null) {
      if (accosApiResults.value.countAll > MaximalAmountDisplayingGeneralEnquiry) {
        return t(`${CULTURE}.enquirybar.generalLabelWithCount`).replace('{count}', MaximalAmountDisplayingGeneralEnquiry.toString())
      } else if (accosApiResults.value.countAll > 1) {
        disableButton.value = false
        return t(`${CULTURE}.enquirybar.generalLabelWithCount`).replace('{count}', accosApiResults.value.countAll.toString())
      } else if (accosApiResults.value.countAll === 1) {
        disableButton.value = false
        return t(`${CULTURE}.enquirybar.singleLabel`)
      } else {
        disableButton.value = true
        return t(`${CULTURE}.enquirybar.noAccosLabel`)
      }
    }
  } else {
    if (ACCOSLISTPAGEFILTER != null) {
      disableButton.value = false
      return t(`${CULTURE}.enquirybar.generalLabelWithCount`).replace('{count}', accosCountEnquiryBar.value)
    } else {
      console.error('accoslistpage filter not passed to vue application')
    }
  }
}
</script>
<template>
  <div class="fixed bottom-0 left-0 right-0 z-50">
    <div class="container mx-auto max-md:p-0">
      <div class="pui-enquirybar md:rounded-t-lg">
        <div class="flex justify-between gap-2 p-3 md:px-4 md:py-3">
          <div class="flex w-3/5">
            <span class="my-auto h-fit font-bold text-white"> {{ text() }}</span>
          </div>
          <div class="flex max-md:w-2/5">
            <button
              @click="$window.siteEvent?.('button', 'enquiry-general', ''), setLocationToEnquiryPage(EnquiryType.General, null, ACCOSLISTPAGEFILTER)"
              :disabled="disableButton"
              class="myEnquiryButton m-auto w-full items-center rounded p-2 md:px-10"
            >
              {{ t(`${CULTURE}.enquirybar.enquiryButton`) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
